import { useTranslation } from 'react-i18next'

import { NUMBER_SIZE } from '../../../constants/size'
import Button from '../../Button'
import { SelectTags } from '../../CustomSelect'

import { getNumberRangeTags } from './FilterNumberRange.utils'

function FilterNumberRange({ label, max, min, qaName, onClear, onClick }) {
  const { t } = useTranslation()

  return (
    <Button.White
      isGrey
      shadowed
      showTextTooltip
      height={NUMBER_SIZE.size32}
      qaName={qaName}
      text={t(label)}
      onClick={onClick}
    >
      <SelectTags
        tags={getNumberRangeTags({ max, min, t })}
        onClose={onClear}
      />
    </Button.White>
  )
}

export default FilterNumberRange
